import { gql, TypedDocumentNode } from "@apollo/client";

export interface AgentToolPermissionGrant {
  uuid: string;
  toolName: string;
  toolAction: string;
  displayName: string;
  policyVersion: string;
  createdAt: string;
  lastUsedAt: string | null;
}

export interface AgentToolPermissionGrantsQuery {
  agentToolPermissionGrants: AgentToolPermissionGrant[];
}

export type AgentToolPermissionGrantsQueryVariables = Record<
  string,
  never
>;

export const GET_AGENT_TOOL_PERMISSION_GRANTS: TypedDocumentNode<
  AgentToolPermissionGrantsQuery,
  AgentToolPermissionGrantsQueryVariables
> = gql`
  query AgentToolPermissionGrants {
    agentToolPermissionGrants {
      uuid
      toolName
      toolAction
      displayName
      policyVersion
      createdAt
      lastUsedAt
    }
  }
`;
